module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.7-249.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.7.md
// module id = 692
// module chunks = 270